import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddressServiceService {

  constructor(
    private http: HttpClient
  ) {

  }

   /**
   * get Recommendation by address and consignee
   */
  getRecommendation(inputObj: any): Observable<any>{
    const url = `${environment.aiUrl}/address/recommendation`;
    return this.http.post(url, inputObj);
  }

  /**
   * get RecommendationAddress by address and consignee
   */
  getRecommendationAddress(inputObj: any): Observable<any>{
    const url = `${environment.aiUrl}/address/recommendationAddress`;
    return this.http.post(url, inputObj);
  }

  /**
   * get RecommendationAddress by address and consignee
   */
  getRecommendationAddressThroughLogistics(inputObj: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/ai/getRecommendationAddress`;
    return this.http.post(url, inputObj);
  }

  /**
   * get RecommendationAddress by address and consignee
   */
  checkUsingShipToAddress(doNo: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/deliveryOrder/checkUsingShipToAddress/${doNo}`;
    return this.http.get(url);
  }

  /**
   * get AssignmentDistrict Options by country
   */
  async getAssignmentDistrict(country: string, city: string): Promise<any>{
    const url = `${environment.aiUrl}/address/assignmentDistrict?country=${country}&city=${city}`;
    return await this.http.get(url).toPromise();
  }

  /**
   * get AssignmentDistrict Options by country
   */
   async getCityOptions(country: string): Promise<any>{
    const url = `${environment.aiUrl}/address/city?country=${country}`;
    return await this.http.get(url).toPromise();
  }

  /**
   * merge address
   * @param addressObj
   */
  mergeAddress(addressObj: any): Observable<any>{
    const url = `${environment.aiUrl}/address/merge`;
    return this.http.post(url, addressObj);
  }

  /**
   * update Do Address
   * @param doNo do No.
   * @param updateObj address & District
   */
  updateDoAddress(updateObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/DeliveryOrder/updateDoAddress`;
    return this.http.patch(url, updateObj);
  }

  /**
   * 找同一個ConsigneeKey+收件公司+地址、尚未正規化、且不在excludeDoNos裡的相同地址DO
   */
  findSameAddressUnnormalizedDeliveryOrders(doNo: string, excludeDoNos: string[]): Observable<any> {
    const url = `${environment.logisticsApiUrl}/deliveryOrder/findSameAddressUnnormalizedDeliveryOrders`;
    return this.http.post(url, { doNo, excludeDoNos });
  }

  /**
   * 把剛確認好的正規化地址資料，批次套用到勾選的相同地址DO上
   */
  batchApplyNormalizedAddress(payload: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/deliveryOrder/batchApplyNormalizedAddress`;
    return this.http.patch(url, payload);
  }

  /**
   * get country
   * @returns country options
   */
  getCountryOptions(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/facility/countryOptions`;
    return this.http.get(url);
  }

  /**
   * dpl Check
   * @param checkObj
   * @returns
   */
   async dplCheck(checkObj: any): Promise<any>{
    const url = `${environment.logisticsApiUrl}/addressDistionary/dplCheck`;
    return await this.http.post(url, checkObj).toPromise();
  }
  /**
   * get Consignee Normalization Address
   * @returns
   */
  getConsigneeNormalizationAddress(consigneeKey: String, deliveryType?: String): Observable<any>{
    const url = `${environment.logisticsApiUrl}/addressDistionary/normalizationAddress/consignee/${consigneeKey}?deliveryType=${deliveryType}`;
    return this.http.get(url);
  }

  /**
   * get Consignee Normalization Address
   * @returns
   */
   getRMBNormalizationAddress(letterOrgId: String): Observable<any>{
    const url = `${environment.logisticsApiUrl}/addressDistionary/normalizationAddress/rmb/${letterOrgId}`;
    return this.http.get(url);
  }

  /**
   * get Consignee Normalization Address
   * @returns
   */
   getCommonNormalizationAddress(facility: String, addressCategory: String, deliveryType?: String): Observable<any>{
    const url = `${environment.logisticsApiUrl}/addressDistionary/normalizationAddress/common/${facility}/${addressCategory}?deliveryType=${deliveryType}`;
    return this.http.get(url);
  }

  getConsigneeReferenAddress(consigneeKey: String): Observable<any>{
    const url = `${environment.logisticsApiUrl}/addressDistionary/referenAddress/consignee/${consigneeKey}`;
    return this.http.get(url);
  }
}
